import React from "react";
import "./styles.css";
import Button from "../CtaButton";

function SimpleModels({ content }) {
  if (!content) return null;

  const { heading, darkHeading, subheading, models, cta, shortHeading } = content;

  return (
    <div className="simple-models-outer-wrapper" id="engagement-models">
      <div className="container">
        <div className="row">
          <div className="simple-models-headings">
            <h2 className="low-top-heading">{shortHeading}</h2>
            <p className="engagement-model-heading">
              {heading} <span>{darkHeading}</span>
            </p>
            <p className="description-text">{subheading}</p>
          </div>
          <div className="simple-models-grid position-relative">
            {models?.map((model, idx) => (
              <div key={idx} className="model-card">
                <img src={model.icon} alt="icon" width={model.iconWidth} />
                <span className="model-index">{model.index}</span>
                <h3 className="model-title">{model.title}</h3>
                <p className="model-desc" dangerouslySetInnerHTML={{
                  __html: model.description,
                }}></p>
                {model?.bestForText && (
                  <>
                    <h4 className="best-for-text">
                      <strong>Best for</strong>
                    </h4>
                    <div className="best-for-tags-boxes">
                      {model?.bestForText?.map((item, index) => (
                        <span key={index} className="best-for-engagement-model-text">
                          {item}
                        </span>
                      ))}
                    </div>
                  </>
                )}

                <ul className="engagement-model-design-list">
                  {model?.includes?.map((list, index) => {
                    return <li key={index}>{list?.description}</li>
                  })}
                </ul>
              </div>
            ))}

            {/* CTA column */}
            {cta && (
              <div className="model-cta position-relative">
                <p className="lead">{cta.text}</p>
                <Button newTab={cta?.nextTab} text={cta.button} link={cta.link} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SimpleModels;
